// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomButton_wrapper__X03c4","input":"CustomButton_input__Z3uLD"};